var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 3",
    filter: "url(#filter0_d_7352_9472)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.5077 44.3334V41.3502C27.4002 41.0021 24.7336 39.7158 22.5081 37.4913C20.2826 35.2668 18.9963 32.6003 18.6493 29.4917H15.666V26.5085H18.6493C18.9973 23.4009 20.2841 20.7344 22.5096 18.5088C24.7351 16.2833 27.4012 14.9971 30.5077 14.65V11.6667H33.491V14.65C36.5985 14.9981 39.2651 16.2848 41.4906 18.5103C43.7161 20.7359 45.0024 23.4019 45.3494 26.5085H48.3327V29.4917H45.3494C45.0014 32.5993 43.7151 35.2658 41.4906 37.4913C39.2661 39.7168 36.5995 41.0031 33.491 41.3502V44.3334H30.5077ZM31.9993 38.4415C34.8832 38.4415 37.3444 37.4222 39.3829 35.3836C41.4215 33.3451 42.4407 30.8839 42.4407 28.0001C42.4407 25.1163 41.4215 22.6551 39.3829 20.6165C37.3444 18.578 34.8832 17.5587 31.9993 17.5587C29.1155 17.5587 26.6543 18.578 24.6158 20.6165C22.5772 22.6551 21.5579 25.1163 21.5579 28.0001C21.5579 30.8839 22.5772 33.3451 24.6158 35.3836C26.6543 37.4222 29.1155 38.4415 31.9993 38.4415ZM31.9993 33.9666C30.3586 33.9666 28.9539 33.3824 27.7855 32.2139C26.6171 31.0455 26.0328 29.6409 26.0328 28.0001C26.0328 26.3593 26.6171 24.9547 27.7855 23.7862C28.9539 22.6178 30.3586 22.0336 31.9993 22.0336C33.6401 22.0336 35.0448 22.6178 36.2132 23.7862C37.3816 24.9547 37.9659 26.3593 37.9659 28.0001C37.9659 29.6409 37.3816 31.0455 36.2132 32.2139C35.0448 33.3824 33.6401 33.9666 31.9993 33.9666Z",
    fill: "#F77E0B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7352_9472",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7352_9472"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7352_9472",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.fddbd3ade169d1d7ea9882dbfb0d50c0.svg";
export { ForwardRef as ReactComponent };